var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"quote","d":"M15.7-31.43H20.32L16.875-20.156H15.141Zm-9.023,0H11.3L7.852-20.156H6.117Z","transform":"translate(-6.117 31.43)","fill":"#677553"}));
}

Quote.defaultProps = {"width":"14.203","height":"11.273","viewBox":"0 0 14.203 11.273"};

module.exports = Quote;

Quote.default = Quote;
